// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__14Q2v","requiredAsterisk":"Info_requiredAsterisk__3kWpW"};